import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardEmbedYoutubeConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:embed-youtube';

  override prepareBlock(youtubeEmbed: BlockSnapshot): PreparedEdgelessBlock {
    return {
      create: () => {
        if (!this.surface) return null;
        const {
          xywh,
          style,
          url,
          caption,
          videoId,
          image,
          title,
          description,
          creator,
          creatorUrl,
          creatorImage,
        } = youtubeEmbed.props;

        const embedYoutubeId = this.crud.addBlock(
          'affine:embed-youtube',
          {
            xywh,
            style,
            url,
            caption,
            videoId,
            image,
            title,
            description,
            creator,
            creatorUrl,
            creatorImage,
          },
          this.surface.model.id
        );
        return embedYoutubeId;
      },
    };
  }
}
